module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAASCAYAAABSO15qAAABW0lEQVQ4jZXSvUtcQRTG4WfNaikSMaVWgl3A+AFpJBYKkkIIChZptLCSpBAxf4CQVIKVBPxAbMQqbCBNIGkUVBKsJFiJKUQwCQo6oIFNcWfx5nL92Lc5c8+c93fPzJxCCEGOOjCNF/H7DAuYwa90YSEHMIG5uP6IA3SiO+a6sHMT4CVWsIixDLgF23iEBpxmAQ/wF9/xJO9cqMUlvqAXalKb/akubtIVlvEM9VlAR4x7twBILhPasoCLGOvuADSm69OAzzH23QGYivFHFrCLI6zfYm7HU7yVXPh/AHGzjA3X717RCL5hE28qybxBGsZaXJ/jRDID4l9r08VZwCxeS4ZkNwKuUEQTHuMYQ5KhUkyZS3iOVbzC72xrEVDCFgbwqdLBPMYxiqUcY1Zf0YOWQgihFfv4gMF7mCsqY6cGkzExXIUZ3qGzEEIo4w8eVgloxkERP/G+SjMcYvEfUDla4j3joE4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-renwu.png
// module id = ll3G
// module chunks = 22